export default "__VITE_ASSET__a608035c__$_?component__"